import { ChromePicker } from 'react-color'

export const ColorPicker = ({ onChange, currentColor }) => {
    return (
        <ChromePicker
            onChange={onChange}
            color={currentColor}
            disableAlpha={true}
        />
    )
}
